import React from 'react'
import { UpdateItemForm } from 'components/form/update-form'

import useGame from 'hooks/useGame'

const QuickForm = (
) => {
  const { model, onUpdate } = useGame()
  const Form = {
    date: {
      component: 'FormDate',
      label: 'Date',
      defaultValue: new Date(model?.date)
    }
  }

  return (
    <UpdateItemForm
      defaultValues={model}
      Form={Form}
      onSubmit={onUpdate}
    />
  )
}

export default QuickForm
